'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutomationAnywhere = (_temp = _class = function (_SvgIcon) {
  _inherits(AutomationAnywhere, _SvgIcon);

  function AutomationAnywhere() {
    _classCallCheck(this, AutomationAnywhere);

    return _possibleConstructorReturn(this, (AutomationAnywhere.__proto__ || Object.getPrototypeOf(AutomationAnywhere)).apply(this, arguments));
  }

  _createClass(AutomationAnywhere, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            {
              id: 'Icons-/-Integrations-/-Automation-Anywhere',
              stroke: 'none',
              strokeWidth: '1',
              fill: 'none',
              fillRule: 'evenodd'
            },
            _react2['default'].createElement(
              'g',
              { id: 'Colors-/-Swatches-/-Transparent' },
              _react2['default'].createElement('rect', { id: 'Swatch', x: '0', y: '0', width: '64', height: '64' })
            ),
            _react2['default'].createElement(
              'g',
              { id: 'Group-34', transform: 'translate(11.000000, 9.000000)' },
              _react2['default'].createElement(
                'g',
                { id: 'Group-33' },
                _react2['default'].createElement(
                  'mask',
                  { id: 'mask-2', fill: 'white' },
                  _react2['default'].createElement('path', {
                    d: 'M18.9310345,-7.10542736e-15 C17.3017241,0.155932203 15.9051724,1.24745763 15.2844828,2.88474576 L0.232758621,44.3619322 C2.77555756e-17,44.9076949 0.310344828,45.6101695 0.931810345,45.7661017 C1.0862069,45.8440678 1.1637931,45.8440678 1.31896552,45.8440678 C1.62931034,45.8440678 2.01724138,45.6881356 2.17241379,45.3770508 C2.17241379,45.2983051 2.25,45.2983051 2.25,45.220339 C4.5,41.4779661 7.60344828,38.2813559 11.4059483,36.0983051 C15.2844828,33.8365085 19.7068966,32.6677966 24.2068966,32.6677966 C26.9224138,32.6677966 29.5603448,33.0568475 32.0431034,33.9152542 L35.2241379,42.4915254 L35.3017241,42.6474576 C36,44.5186441 37.7068966,45.6881356 39.6465517,45.6881356 C42.1797414,45.6881356 44.2582759,43.6259322 44.3017241,41.0896949 L44.3017241,40.9501356 C44.2869828,40.337322 44.0588793,39.5872881 43.7586207,38.9830508 C43.6042241,38.7491525 43.4482759,38.5152542 43.2931034,38.2813559 C43.2155172,38.2033898 43.137931,38.0474576 43.0603448,37.9694915 C40.3448276,35.3966102 37.1637931,33.4474576 33.75,32.2 L33.5172414,31.5762712 L23.0431034,2.88474576 C22.4224138,1.24745763 21.0258621,0.0779661017 19.3965517,-7.10542736e-15 L18.9310345,-7.10542736e-15 Z M17.3017241,3.66440678 C17.612069,2.806 18.3103448,2.26023729 19.0862069,2.18305085 C19.862069,2.18305085 20.5603448,2.806 20.8706897,3.66440678 L30.9568966,31.420339 C28.7844828,30.7966102 26.5344828,30.4847458 24.2068966,30.4847458 C19.3189655,30.4847458 14.5086207,31.8101695 10.3189655,34.2271186 C8.22413793,35.4745763 6.36206897,36.9559322 4.65517241,38.5932203 L17.3017241,3.66440678 Z M37.3189655,41.9457627 L37.3189655,41.8685763 L37.2413793,41.6338983 L34.7586207,35.0847458 C37.0862069,36.1762712 39.1810345,37.5804407 41.1206897,39.2941356 C41.3534483,39.5288136 41.5862069,39.7634915 41.7413793,40.0737966 C41.8965517,40.4644068 42.0517241,40.7762712 42.0517241,41.2440678 C42.0517241,42.4915254 40.9647414,43.5822712 39.6465517,43.5822712 C38.637931,43.5822712 37.7068966,42.8813559 37.3189655,41.9457627 Z',
                    id: 'path-1'
                  })
                ),
                _react2['default'].createElement('g', { id: 'Clip-2' }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-1',
                  fill: '#F15D29',
                  mask: 'url(#mask-2)',
                  points: '34.7586207 43.5830508 35.4856034 43.5830508 35.4856034 35.0855254 34.7586207 35.0855254'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-3',
                  fill: '#F15D29',
                  mask: 'url(#mask-2)',
                  points: '35.4863793 43.5830508 39.695431 43.5830508 39.695431 35.0855254 35.4863793 35.0855254'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-4',
                  fill: '#F15A29',
                  mask: 'url(#mask-2)',
                  points: '39.695431 43.5822712 42.0525 43.5822712 42.0525 35.0847458 39.695431 35.0847458'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-5',
                  fill: '#FCB425',
                  mask: 'url(#mask-2)',
                  points: '4.65517241 38.5932203 6.59637931 38.5932203 6.59637931 2.18305085 4.65517241 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-6',
                  fill: '#FCB425',
                  mask: 'url(#mask-2)',
                  points: '6.59637931 38.5932203 9.20094828 38.5932203 9.20094828 2.18305085 6.59637931 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-7',
                  fill: '#F89928',
                  mask: 'url(#mask-2)',
                  points: '9.20094828 38.5932203 11.8055172 38.5932203 11.8055172 2.18305085 9.20094828 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-8',
                  fill: '#F89928',
                  mask: 'url(#mask-2)',
                  points: '11.8055172 38.5932203 14.5031897 38.5932203 14.5031897 2.18305085 11.8055172 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-9',
                  fill: '#F58429',
                  mask: 'url(#mask-2)',
                  points: '14.5024138 38.5932203 17.2000862 38.5932203 17.2000862 2.18305085 14.5024138 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-10',
                  fill: '#F58429',
                  mask: 'url(#mask-2)',
                  points: '17.2000862 38.5932203 20.0257759 38.5932203 20.0257759 2.18305085 17.2000862 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-11',
                  fill: '#F37329',
                  mask: 'url(#mask-2)',
                  points: '20.0257759 38.5932203 22.8514655 38.5932203 22.8514655 2.18305085 20.0257759 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-12',
                  fill: '#F37329',
                  mask: 'url(#mask-2)',
                  points: '22.8506897 38.5932203 25.8571552 38.5932203 25.8571552 2.18305085 22.8506897 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-13',
                  fill: '#F26529',
                  mask: 'url(#mask-2)',
                  points: '25.8571552 38.5932203 28.8636207 38.5932203 28.8636207 2.18305085 25.8571552 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-14',
                  fill: '#F26529',
                  mask: 'url(#mask-2)',
                  points: '28.8636207 38.5932203 30.9568966 38.5932203 30.9568966 2.18305085 28.8636207 2.18305085'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-15',
                  fill: '#FFDE17',
                  mask: 'url(#mask-2)',
                  points: '2.22044605e-16 45.8440678 0.155172414 45.8440678 0.155172414 -7.10542736e-15 2.22044605e-16 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-16',
                  fill: '#FFDE17',
                  mask: 'url(#mask-2)',
                  points: '0.155172414 45.8440678 0.892241379 45.8440678 0.892241379 -7.10542736e-15 0.155172414 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-17',
                  fill: '#FFD31C',
                  mask: 'url(#mask-2)',
                  points: '0.892241379 45.8440678 1.62931034 45.8440678 1.62931034 -7.10542736e-15 0.892241379 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-18',
                  fill: '#FFD31C',
                  mask: 'url(#mask-2)',
                  points: '1.62931034 45.8440678 4.11284483 45.8440678 4.11284483 -7.10542736e-15 1.62931034 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-19',
                  fill: '#FCB425',
                  mask: 'url(#mask-2)',
                  points: '4.11284483 45.8440678 6.59637931 45.8440678 6.59637931 -7.10542736e-15 4.11284483 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-20',
                  fill: '#FCB425',
                  mask: 'url(#mask-2)',
                  points: '6.59637931 45.8440678 9.20094828 45.8440678 9.20094828 -7.10542736e-15 6.59637931 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-21',
                  fill: '#F89928',
                  mask: 'url(#mask-2)',
                  points: '9.20094828 45.8440678 11.8055172 45.8440678 11.8055172 -7.10542736e-15 9.20094828 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-22',
                  fill: '#F89928',
                  mask: 'url(#mask-2)',
                  points: '11.8055172 45.8440678 14.5031897 45.8440678 14.5031897 -7.10542736e-15 11.8055172 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-23',
                  fill: '#F58429',
                  mask: 'url(#mask-2)',
                  points: '14.5024138 45.8440678 17.2000862 45.8440678 17.2000862 -7.10542736e-15 14.5024138 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-24',
                  fill: '#F58429',
                  mask: 'url(#mask-2)',
                  points: '17.2000862 45.8440678 20.0257759 45.8440678 20.0257759 -7.10542736e-15 17.2000862 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-25',
                  fill: '#F37329',
                  mask: 'url(#mask-2)',
                  points: '20.0257759 45.8440678 22.8514655 45.8440678 22.8514655 -7.10542736e-15 20.0257759 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-26',
                  fill: '#F37329',
                  mask: 'url(#mask-2)',
                  points: '22.8506897 45.8440678 25.8571552 45.8440678 25.8571552 -7.10542736e-15 22.8506897 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-27',
                  fill: '#F26529',
                  mask: 'url(#mask-2)',
                  points: '25.8571552 45.8440678 28.8636207 45.8440678 28.8636207 -7.10542736e-15 25.8571552 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-28',
                  fill: '#F26529',
                  mask: 'url(#mask-2)',
                  points: '28.8636207 45.8440678 32.175 45.8440678 32.175 -7.10542736e-15 28.8636207 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-29',
                  fill: '#F15D29',
                  mask: 'url(#mask-2)',
                  points: '32.1742241 45.8440678 35.4856034 45.8440678 35.4856034 -7.10542736e-15 32.1742241 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-30',
                  fill: '#F15D29',
                  mask: 'url(#mask-2)',
                  points: '35.4863793 45.8440678 39.695431 45.8440678 39.695431 -7.10542736e-15 35.4863793 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-31',
                  fill: '#F15A29',
                  mask: 'url(#mask-2)',
                  points: '39.695431 45.8440678 43.9044828 45.8440678 43.9044828 -7.10542736e-15 39.695431 -7.10542736e-15'
                }),
                _react2['default'].createElement('polygon', {
                  id: 'Fill-32',
                  fill: '#F15A29',
                  mask: 'url(#mask-2)',
                  points: '43.9044828 45.8440678 44.3017241 45.8440678 44.3017241 -7.10542736e-15 43.9044828 -7.10542736e-15'
                })
              )
            )
          )
        );
      }

      return render;
    }()
  }]);

  return AutomationAnywhere;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = AutomationAnywhere;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/AutomationAnywhere.js
// module id = 1353
// module chunks = 32